import React from 'react';
import PropTypes from 'prop-types';
import uniqBy from 'lodash.uniqby';
import { useDispatch, useSelector } from 'react-redux';
import { IoMdTime } from "@react-icons/all-files/io/IoMdTime";

import {
  Button
} from 'day8-ui';
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';

const BoatYear = props => {
  const dispatch = useDispatch();
  const yachts = useSelector(state => state.yachts.items);
  const boatYearOptions = uniqBy(yachts, 'boat.year')
    .map(yacht => yacht.boat.year)
    .sort((a, b) => a - b);
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.BOAT_YEAR].map(item => item).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Boat Year</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {boatYearOptions.map(year => (
          <Button key={year} buttonType={isFilterSelected(props.location, FILTERS.BOAT_YEAR, year) ? "FILTER_ACTIVE" : "FILTER"} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.BOAT_YEAR, year)}>{year}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoMdTime />}>{selectedFilterText || 'Boat Year'}</Button>;
};
BoatYear.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.bool
};
export default BoatYear;
